import React, { Component } from "react";
import Theme from "css/themes/media-market/util/comment-dropdown-theme.css";
import { bool, func } from "prop-types";
import { Menu, MenuItem } from "react-toolbox/lib/menu";

export default class CommentDropdownMenu extends Component {
  static propTypes = {
    active: bool.isRequired,
    editComment: func.isRequired,
    deleteComment: func.isRequired,
  };

  render() {
    const { active, editComment, deleteComment } = this.props;

    return (
      <Menu
        position="topRight"
        active={active}
        theme={Theme}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <MenuItem value="edit" caption="Edit" onClick={editComment} theme={Theme} />
        <MenuItem value="delete" caption="Delete" onClick={deleteComment} theme={Theme} />
      </Menu>
    );
  }
}
